import { BookingMode } from "../../sessions/enums/BookingMode";
import { BookableSlotResponse } from "../contracts/BookableSlotResponse";
import { BookableSlotsResponse } from "../contracts/BookableSlotsResponse";
import { BookableSlot, BookableSlots } from "../models/BookableSlots";

const toSlot = (response: BookableSlotResponse): BookableSlot => {
  const timeLocal = response.timeLocal.slice(0, 5);
  return {
    key: `${response.date}T${timeLocal}`,
    date: response.date,
    timeLocal,
    unitMinutes: response.unitMinutes,
    bookingMode: response.bookingMode,
    defaultTopicId: response.defaultTopicId ?? null,
    defaultTopicTitle: response.defaultTopicTitle ?? null,
    needsConfirmation: response.bookingMode === BookingMode.OpenWithConfirmation,
  };
};

/** Wire → model: slots grouped by date in start order; a missing response reads as no instructor. */
export const mapResponseToBookableSlots = (
  response: BookableSlotsResponse | null | undefined,
): BookableSlots => {
  const days = new Map<string, BookableSlot[]>();
  for (const slot of (response?.slots ?? []).map(toSlot)) {
    days.set(slot.date, [...(days.get(slot.date) ?? []), slot]);
  }
  return {
    hasInstructor: !!response?.instructorId,
    organizationPublishesSlots: response?.organizationPublishesSlots ?? false,
    instructorId: response?.instructorId ?? null,
    instructorName: response?.instructorName ?? null,
    timeZone: response?.timeZone ?? null,
    days: [...days.entries()]
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([date, slots]) => ({ date, slots: slots.sort((a, b) => a.timeLocal.localeCompare(b.timeLocal)) })),
  };
};
